import { Region } from "shared-lib";
import { TransmissionStation } from "shared-lib";

export class F33Crud {
  id: number;
  name: string;
  number: string;
  transmissionStation: TransmissionStation;
  transmissionStationId: number;
  checked: boolean;
  utilityId: number;
  regions: Region[];
  currentRegions: string;
  guid: string;
  code: string;
}

export class F33CrudCreate {
  id: number;
  name: string;
  number: string;
  transmissionStationId: number;
  utilityId: number;
  regionIds: number[];
}

export function mapObjToCreateObj(f33: F33Crud): F33CrudCreate {
  return {
    id: f33.id,
    name: f33.name,
    number: f33.number,
    transmissionStationId: f33.transmissionStation.id,
    utilityId: f33.utilityId,
    regionIds: f33.regions.map((x) => x.id),
  };
}

export interface Feeder33 {
  id: number;
  name: string;
  number: string;
  transmissionStation?: string;
}
